import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Image,
    Input,
    InputGroup,
    InputLeftElement,
    Text,
    useToast,
  } from "@chakra-ui/react";
  import { useState } from "react";
  import { CiLock } from "react-icons/ci";
  import { useNavigate } from "react-router-dom";
  import naptinlogo from "../../img/naptinlogo.png";
  import mail_icon from "../../img/red_mail_icon.svg";
  import routes from "../routes";

  const PendingVerification = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const email = localStorage.getItem("userMail")?.toString();
    const [token, setToken] = useState("");
    const login = () => {
      localStorage.removeItem("userMail");
      navigate(routes.Login);
    };
  

    return (
      <>
        <Box>
          <Flex
            height="50px"
            bg="#FFFFFF"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px={"10px"}
          >
            <Flex alignItems="center">
              <Box as="span">
                <Image src={naptinlogo} height="45px" />
              </Box>
            </Flex>
          </Flex>
        </Box>
        <Flex
          width="100%"
          justifyContent="center"
          alignItems={"center"}
          height="100vh"
          bg=" #F9F8F8"
        >
          <Box
            boxShadow="base"
            bg="white"
            borderRadius="20px"
            height="450px"
            width="45%"
            color="#353535"
            textAlign="center"
            padding={"3rem"}
          >
            <Flex justifyContent="flex-start" mt="20px">
              <Image src={mail_icon} />
            </Flex>
            <Text
              fontSize="24px"
              fontWeight="500"
              pt="45px"
              pb="14px"
              textAlign={"left"}
            >
              Thank you for registering on our platform
            </Text>
            <Text
              fontSize="20px"
              fontWeight="500"
              pt="4px"
              pb="14px"
              textAlign={"left"}
            >
              Please wait for the admin to approve your registration, you will be notified once this is done
            </Text>

            <Button
              py="13px"
              px="30px"
              float={"right"}
              onClick={() => {
                navigate(routes.LandingPage)
              }}
              fontSize={14}
              borderRadius={2}
              colorScheme="red"
              size="xl"
            >
              GO BACK
            </Button>
          </Box>
        </Flex>
      </>
    );
  };
  
  export default PendingVerification;
  